import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { useRagOverview } from "../api";

/** Sentinel for "no filter". Radix Select forbids an empty-string item value,
 *  so the clear option needs a real value that we map back to undefined. */
const ANY = "__any__";

/**
 * Repo + language pickers, shared by the Search and Ask tabs. Both option lists
 * come from the same facet counts the Overview tab renders, so the dropdowns can
 * only ever offer values that actually exist in the index.
 */
export function FilterSelects({
  repo,
  lang,
  onChange,
  disabled,
}: {
  repo?: string;
  lang?: string;
  onChange: (next: { repo?: string; lang?: string }) => void;
  disabled?: boolean;
}) {
  const { data } = useRagOverview();

  return (
    <>
      <Select
        value={repo ?? ANY}
        onValueChange={(v) => onChange({ repo: v === ANY ? undefined : v })}
        disabled={disabled}
      >
        <SelectTrigger className="w-52">
          <SelectValue placeholder="All repos" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ANY}>All repos</SelectItem>
          {(data?.repos ?? []).map((r) => (
            <SelectItem key={r.repo} value={r.repo}>
              {r.repo}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={lang ?? ANY}
        onValueChange={(v) => onChange({ lang: v === ANY ? undefined : v })}
        disabled={disabled}
      >
        <SelectTrigger className="w-40">
          <SelectValue placeholder="All languages" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ANY}>All languages</SelectItem>
          {/* The backend already drops blank facet values; this guard stays
              because a single empty-string item throws inside Radix and takes
              the whole page down with it — far too harsh a failure for one
              unclassifiable file to cause. */}
          {(data?.languages ?? [])
            .filter((l) => l.value.trim() !== "")
            .map((l) => (
              <SelectItem key={l.value} value={l.value}>
                {l.value}
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
    </>
  );
}
